<template>
  <div class="icpmyorder">
    <div class="icpmyorderTitle">
      <div>全部服务单</div>
    </div>
    <div class="icpmyorderMsg">
      <div class="icpmyorderMsg-main">
        <div class="icpmyorderMsg-main-left">
          <el-row class="tac">
            <el-col :span="4">
              <el-menu
                :default-active="tabsIndex == 'dqr' ? '2-1' : '2-2'"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose"
              >
                <el-submenu
                  :index="item.type"
                  v-for="item in navList"
                  :key="item.type"
                >
                  <template slot="title">
                    <i :class="item.icon"></i>
                    <span>{{ item.name }}</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item
                      :index="item.type + '-' + ite.type"
                      v-for="ite in item.list"
                      :key="ite.type"
                      @click="handleChangeTabs(ite)"
                      ><i :class="ite.icon"></i> {{ ite.name }}</el-menu-item
                    >
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </el-col>
          </el-row>
        </div>
        <div class="icpmyorderMsg-main-right">
          <div class="icpmyorderMsg-main-order">
            <router-view> </router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      navList: [
        // {
        //   name: '我的订单',
        //   type: '1',
        //   icon: 'iconfont icon-integral',
        //   list: [
        //     {
        //       name: '待支付',
        //       type: '1',
        //       icon: 'iconfont icon-daizhifu2'
        //     },
        //     {
        //       name: '全部订单',
        //       type: '2',
        //       icon: 'iconfont icon-xiugai'
        //     }
        //   ]
        // },
        {
          name: '已购服务',
          type: '2',
          icon: 'iconfont icon-weituoguan',
          list: [
            {
              name: '等待我处理',
              type: '1',
              icon: 'iconfont icon-shijian3',
            },
            {
              name: '全部服务单',
              type: '2',
              icon: 'iconfont icon-biaodanyemian',
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      tabsIndex: (state) => state.alfillmaterials.tabsIndex,
    }),
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleChangeTabs(ite) {
      this.$store.commit(
        'alfillmaterials/changeTabsIndex',
        ite.type == 2 ? 'author' : 'dqr'
      );
      // console.log(ite, this.tabsIndex);
    },
  },
};
</script>

<style lang="scss">
.icpmyorder {
  width: 100%;
  height: 100%;
  background: #f5f5f6;
  padding: 0 0 50px 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .icpmyorderTitle {
    width: 100%;
    padding: 20px 0;
    background: #fff;
    div {
      width: 1415px;
      margin: 0 auto;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 20px;
    }
  }
  .icpmyorderMsg {
    width: 1415px;
    height: calc(100% - 60px);
    margin: 0px auto;
    padding-top: 30px;
  }
}
.icpmyorderMsg-main {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  margin-bottom: 50px;
  display: flex;
  .icpmyorderMsg-main-left {
    width: 206px;
    height: 100%;
    background: #fff;
    margin-right: 10px;
    padding: 15px 0;
    .el-menu-item.is-active {
      border-left: 5px solid #ff6a00;
      color: #ff6a00 !important;
      background: rgba(255, 106, 0, 0.13);
      i {
        margin-left: 9px !important;
      }
      // padding-left: 40px;
    }
    .el-row {
      .el-col-4 {
        width: 100%;
        .el-menu {
          border: none;
        }
        .el-submenu {
          .el-submenu__title {
            height: 40px;
            display: flex;
            align-items: center;
            i {
              font-size: 20px;
            }
            span {
              margin-left: 18px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(0, 0, 0, 0.85);
              line-height: 22px;
            }
          }
          .el-submenu__title:hover {
            background: rgba(255, 106, 0, 0.13);
          }
          .el-menu-item-group__title {
            padding: 0;
          }
          .el-menu-item {
            height: 40px;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 22px;
            color: #8d8d90;
            i {
              margin-right: 10px;
              margin-left: 14px;
              font-size: 18px;
            }
          }
          .el-menu-item:hover,
          .el-menu-item:focus {
            background: rgba(255, 106, 0, 0.13);
          }
          .el-menu-item:focus {
            border-left: 5px solid #ff6a00;
            color: rgba(255, 106, 0, 1);
            i {
              margin-left: 9px;
            }
          }
        }
      }
    }
  }
  .icpmyorderMsg-main-right {
    flex: 1;
    background: #fff;
    .icpmyorderMsg-main-order {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
